import { AdminLayout } from '../../components/admin/layout/AdminLayout';
import { ModulesManagement } from '../../components/admin/ModulesManagement';

export function ModulesPage() {
  return (
    <AdminLayout
      title="Modules métiers"
      description="Gérez les modules fonctionnels de la plateforme"
    >
      <ModulesManagement />
    </AdminLayout>
  );
}
